import script from "./MailEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./MailEditView.vue?vue&type=script&lang=ts&setup=true"

import "./MailEditView.vue?vue&type=style&index=0&id=7eb296bc&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7eb296bc"]])

export default __exports__